import { useMutationApi, useQueryApi } from 'utils/api'

import type { UseMutationOptions } from 'react-query'
import type {
  RequestGetKinerjaNotificationList,
  ResponseGetKinerjaNotificationList,
} from 'types/kinerja-notification'

const basePath = '/guru/skp'

export const API_PATH_NOTIFICATION_LIST = `${basePath}/v1/notification/list`
export function useAPIGetNotificationList({
  options,
}: RequestGetKinerjaNotificationList = {}) {
  return useQueryApi<ResponseGetKinerjaNotificationList>(
    API_PATH_NOTIFICATION_LIST,
    {
      queryConfig: {
        ...options,
      },
    }
  )
}

export function useAPIMarkAllNotificationsAsRead(
  opts?: UseMutationOptions<unknown, Error, {}>
) {
  return useMutationApi(`${basePath}/v1/notification/read`, {
    axiosConfig: {
      method: 'PATCH',
    },
    mutationConfig: {
      ...opts,
    },
  })
}
